import CreateRatingPage from './CreateRatingPage'

export default CreateRatingPage
